import React, { FC } from 'react'
import styles from './MoreLink.module.scss'
import { CardEntity } from '../../ducks/cards/types'

interface PropsType {
  card: CardEntity
}

const MoreLink: FC<PropsType> = ({card}) => (
  <a href={ card.servicesLink } target="_blank" rel="noopener">
    <div className={ styles.servicesLinkContent }>
      <div className= { styles.imageContent }>
        { card.imageURL && card.imageURL.large ? <img src={ card.imageURL.large } /> : <span className={ styles.noImage }>No Image </span> }
      </div>
      <div className={ styles.textContent }>
        <p>
          <span className={ styles.name }>
            { card.name }（{ card.ruby }）
          </span>
          <br/>が出演する作品をもっとみる
        </p>
      </div>
    </div>
  </a>
)

export default MoreLink
